import { useMediaQuery, useTheme } from "@material-ui/core";

/**
 * Get the amount of cards visible in viewport for current media query
 */
export function useViewportCardsCount() {
  const theme = useTheme();
  const isMqLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isMqMd = useMediaQuery(theme.breakpoints.up("md"));
  let columnsCount = 2;
  if (isMqMd) {
    columnsCount = 3;
  }
  if (isMqLg) {
    columnsCount = 4;
  }
  return columnsCount;
}
